import React from "react";
import { Link, useLocation } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

// Custom breadcrumb for clients — reads buyer_type from query param
const ClientsBreadcrumb = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const buyerType = params.get("buyer_type");
  if (buyerType === "legal") return <span>Legal Clients</span>;
  return <span>Natural Clients</span>;
};

const routes = [
  // Financials
  { path: "/financial", breadcrumb: "Financials" },
  { path: "/financial/contracts", breadcrumb: "Contracts" },
  { path: "/financial/contracts/:id", breadcrumb: "Contract Detail" },
  { path: "/financial/invoices", breadcrumb: "Invoices" },
  { path: "/financial/invoices/overdue", breadcrumb: "Overdue" },
  { path: "/financial/invoices/vendors", breadcrumb: "Vendor Invoices" },
  { path: "/financial/invoices/vendors/:cif", breadcrumb: "Vendor Detail" },


  // Inventory / Units
  { path: "/units-by-block", breadcrumb: null },
  { path: "/units-by-block/:blockId", breadcrumb: "Units" },

  // Reporting
  { path: "/project-reporting", breadcrumb: null },
  { path: "/project-reporting/:id", breadcrumb: "Project Reporting" },

  // Management
  { path: "/projects", breadcrumb: "Projects" },
  { path: "/phases", breadcrumb: "Phases" },
  { path: "/blocks", breadcrumb: "Blocks" },

  // Admin
  { path: "/admin", breadcrumb: "Admin" },
  { path: "/admin/panel", breadcrumb: "Panel" },
  { path: "/admin/panel/users", breadcrumb: "Users" },
  { path: "/admin/panel/users/:id", breadcrumb: "User Detail" },
  { path: "/admin/panel/accounts", breadcrumb: "Accounts" },
  { path: "/admin/panel/accounts/add-accounts", breadcrumb: "Add Account" },
  { path: "/admin/panel/accounts/:id", breadcrumb: "Account Detail" },

  // Details
  { path: "/client-details/:id", breadcrumb: "Client Detail" },
  { path: "/project-details/:id", breadcrumb: "Project Detail" },
  { path: "/block-details/:id", breadcrumb: "Block Detail" },
  { path: "/phase-details/:id", breadcrumb: "Phase Detail" },
  { path: "/unit-details/:id", breadcrumb: "Unit Detail" },
  { path: "/payment-details/:id", breadcrumb: "Payment Detail" },
  { path: "/settlement-details/:id", breadcrumb: "Settlement Detail" },

  // Profile
  { path: "/pages-profile-settings", breadcrumb: "Profile Settings" },
];

const AppBreadcrumb = () => {
  const breadcrumbs = useBreadcrumbs(routes, { disableDefaults: true });

  if (breadcrumbs.length <= 1) return null;

  return (
    <div className="page-title-box d-flex align-items-center justify-content-between mb-4">
      <h4 className="mb-0 fw-bold" style={{ color: "#002045" }}>
        {breadcrumbs[breadcrumbs.length - 1].breadcrumb}
      </h4>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb m-0">
          {breadcrumbs.map(({ match, breadcrumb }, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <li
                key={match.pathname}
                className={`breadcrumb-item${isLast ? " active" : ""}`}
              >
                {isLast ? (
                  breadcrumb
                ) : (
                  <Link to={match.pathname}>{breadcrumb}</Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default AppBreadcrumb;
